import React from 'react';
import {Card} from "../../../../../components/card/card.jsx";
import SentryRow from "../../../../../components/template/sentry-row.jsx";
import FormField from "../../../../../components/react-hook-form/form-field.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import {BoKeys} from "../../resources/bo-keys.js";
import InputForm from "../../../../../components/input/input-form.jsx";
import optionsUtils from "../../../../../utils/options-utils.js";

const areaOptions = [
    {value: "ANTRHOPIZED", label: BoKeys.ANTRHOPIZED},
    {value: "APP", label: BoKeys.APP},
    {value: "RURAL", label: BoKeys.RURAL},
    {value: "UC", label: BoKeys.UC},
    {value: "URBAN", label: BoKeys.URBAN},
    {value: "DAMPING_ZONE", label: BoKeys.DAMPING_ZONE},
];

const adminPenaltyOptions = [
    {value: "WARNING", label: BoKeys.WARNING},
    {value: "APPREHENSION", label: BoKeys.APPREHENSION},
    {value: "EMBARGO", label: BoKeys.EMBARGO},
    {value: "CLOSURE", label: BoKeys.CLOSURE},
    {value: "INTERDICTION", label: BoKeys.INTERDICTION},
    {value: "SEALING", label: BoKeys.SEALING},
    {value: "FINE", label: BoKeys.FINE},
    {value: "NOTIFICATION", label: BoKeys.NOTIFICATION},
    {value: "ORIENTATION", label: BoKeys.ORIENTATION},
    {value: "REMOVAL", label: BoKeys.REMOVAL},
    {value: "PARTIAL_SUSPENSION", label: BoKeys.PARTIAL_SUSPENSION},
    {value: "TOTAL_SUSPENSION", label: BoKeys.TOTAL_SUSPENSION},
];

const blockInvalidNumberInput = (event) => {
    if (["-", ".", ",", "+", "e", "E"].includes(event.key)) {
        event.preventDefault();
    }
};

const BoFormExtraInfo = () => {
    return (
        <Card>
            <Card.Header>
                <Card.Title>Outras informações</Card.Title>
            </Card.Header>

            <Card.Body className={"space-y-4"}>
                <section className={"space-y-3"}>
                    <h3 className={"text-sm font-semibold text-gray-500"}>Ambiental</h3>

                    <SentryRow>
                        <FormField
                            name={"extraInfo.area"}
                            customRender={field => (
                                <SelectComponent
                                    instanceId={"extraInfo.area"}
                                    classNameWrapper={"col-span-6"}
                                    value={field.value}
                                    options={areaOptions}
                                    label={"Área"}
                                    onChange={(selected) => field.onChange(selected?.value)}
                                />
                            )}
                        />

                        <FormField
                            name={"extraInfo.adminPenalty"}
                            customRender={field => (
                                <SelectComponent
                                    instanceId={"extraInfo.adminPenalty"}
                                    classNameWrapper={"col-span-6"}
                                    value={field.value}
                                    options={adminPenaltyOptions}
                                    label={"Sanção administrativa imposta"}
                                    onChange={(selected) => field.onChange(selected?.value)}
                                />
                            )}
                        />
                    </SentryRow>
                </section>

                <section className={"space-y-3 border-t border-[#e5e7eb] pt-4"}>
                    <h3 className={"text-sm font-semibold text-gray-500"}>Evento</h3>

                    <SentryRow>
                        <FormField
                            as={InputForm}
                            name={"extraInfo.eventName"}
                            label={"Nome"}
                            classNameWrapper={"col-span-9"}
                        />

                        <FormField
                            name={"extraInfo.eventPersonQuantity"}
                            customRender={field => (
                                <InputForm
                                    id={"extraInfo.eventPersonQuantity"}
                                    name={field.name}
                                    label={"Total de participantes"}
                                    classNameWrapper={"col-span-3"}
                                    type={"number"}
                                    min={0}
                                    value={field.value}
                                    onChange={field.onChange}
                                    onKeyDown={blockInvalidNumberInput}
                                />
                            )}
                        />
                    </SentryRow>
                </section>
            </Card.Body>
        </Card>
    );
};

export default BoFormExtraInfo;
